<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div id="square-container" [innerHTML]='"copy.html.FIBContact.ContactCopy"|copy|async'></div>
    </div>
</div>